import clsx from 'clsx';
import { useEffect, useRef, useState } from 'react';
import { Modal } from 'react-responsive-modal';
import { Button } from './Button';
import Pill from './Pill';

const ProcessModal = ({ children, pModalContent = null, processModal = () => { } }) => {
  const [modalContent, setModalContent] = useState({
    title: "",
    paymentStatus: "",
    msg: "",
    isOpen: false,
    isProcess: false,
    isConfirm: false,
    buyAgain: false,
    payNow: false,
    isAlert: false,
    innerContent: null
  });

  useEffect(() => {
    setModalContent(pModalContent);
  }, [pModalContent])

  const onCloseModal = () => setModalContent({ ...modalContent, isOpen: false })

  const handleSave = () => {
    setModalContent({ ...modalContent, isOpen: false })
    processModal()
  }

  return (
    modalContent &&
    <Modal open={modalContent.isOpen} onClose={onCloseModal} center classNames={{ modal: 'w-4/5 sm:w-3/5 lg:w-1/2' }}>
      <div className="flex items-start border-b-[1px]">
        <h2 className="font-medium font-agcasmlt text-[#6e605d] pb-2 text-xl">{modalContent.title ? modalContent.title : "Information"}
        </h2>
        {modalContent.paymentStatus &&
          <>
            {/* <span className="text-base font-normal">{modalContent.status}</span> */}
            <Pill status={modalContent.paymentStatus} />
          </>
        }
      </div>
      <div className="py-6 px-3">
        {modalContent.msg ?
          <p className="font-agcasmlt text-lg font-light text-charcoal-black">
            {modalContent.msg}
          </p>
          :
          children
        }
      </div>
      <div className="border-t-[1px] pt-2 w-full flex justify-end">
        <div className={clsx("w-full", { "flex gap-2 md:w-2/5": (modalContent.isProcess || modalContent.isConfirm || modalContent.buyAgain || modalContent.payNow), "flex justify-end": !(modalContent.isProcess || modalContent.isConfirm || modalContent.buyAgain || modalContent.payNow) })}>
          {(modalContent.isProcess || modalContent.isConfirm || modalContent.buyAgain || modalContent.payNow || modalContent.isAlert) && (
            <div className={clsx({ "w-full": !modalContent.isAlert, "w-2/5": modalContent.isAlert })}>
              <Button processBtn onClickBtn={handleSave} title={modalContent.isConfirm ? "Yes" : modalContent.buyAgain ? "Buy again" : modalContent.payNow ? "Pay now" : modalContent.isAlert ? "Okay" : "Save"} custCls="text-sm tracking-wide pt-1.5 pb-0.5 font-extralight" borderColor="border-[#bc9c5c]" bgColor="bg-[#bc9c5c]" />
            </div>
          )}
          {!modalContent.isAlert &&
            <div className={clsx({ "w-full": (modalContent.isProcess || modalContent.isConfirm || modalContent.buyAgain || modalContent.payNow), "w-2/5": !(modalContent.isProcess || modalContent.isConfirm || modalContent.buyAgain || modalContent.payNow) })}>
              <Button title={modalContent.isProcess ? "Cancel" : modalContent.isConfirm ? "No" : "Close"} processBtn onClickBtn={onCloseModal} onlyBorder custCls="text-sm tracking-wide pt-1.5 pb-0.5 font-normal" />
            </div>
          }
        </div>
      </div>
    </Modal>
  )
}

export default ProcessModal;